import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  title = 'Navbar Heading 1';
  subtitle = 'Navbar Heading 2';
  titleSpanish = 'Rumbo de la barra de navegación 1';
  subtitleSpanish = 'Rumbo de la barra de navegación 2';
  titleHindi = 'नवबार शीर्षक 1';
  subtitleHindi = 'नवबार शीर्षक 2';
  hamburgerAriaLabel = 'More';
  closeButtonAriaLabel = 'Close';
  backButtonAriaLabel = 'Back';
  hamburgerAriaLabelInSpanish = 'Más';
  closeButtonAriaLabelInSpanish = 'Cerca';
  backButtonAriaLabelInSpanish = 'atrás';
  hamburgerAriaLabelInHindi = 'अधिक';
  closeButtonAriaLabelInHindi = 'बंदकरे';
  backButtonAriaLabelInHindi = 'पीछे';
  backUrl = '/button';
  links = [
    {
      id: 'link',
      label: 'action',
      url: '/card',
      icon: 'icon-plus',
      position: 'left',
      color: 'primary'
    },
    {
      id: 'Enlace',
      label: 'acción',
      url: '/modal-header',
      icon: 'icon-plus',
      position: 'right',
      color: 'primary'
    },
    {
      id: 'संपर्क',
      label: 'बुलावा',
      url: '/button',
      icon: 'icon-plus',
      position: 'right',
      color: 'primary'
    }
  ];
}